export const backendserverurl='https://3-be-newpitechsms-gatewaybackend.pitech.co.ug'

//127.0.0.1:8000
//157.245.89.89
//https://1-be-pifs01-mta-app1.pitech.co.ug

//https://3-be-newpitechsms-gatewaybackend.pitech.co.ug/

